import './perks-videos.component.scss';

import { h } from 'preact';
import { useMemo } from 'preact/hooks';

import { SpinnerComponent } from '../../../common/components/spinner/spinner.component';
import { useTranslation } from '../../../i18n';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ContentType } from '../../model/tab.interface';
import {
  selectPerksLoading,
  selectTabContentLast,
  selectTabContentNextCursor,
  selectVideos,
} from '../../store/perks.selectors';
import { loadTabContent } from '../../store/perks.thunk';
import { usePerksConfig } from '../perks/perks-config.context';
import { PerksVideo } from './perks-video.component';

export const PerksVideosComponent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectPerksLoading);
  const videos = useAppSelector(selectVideos);
  const isLast = useAppSelector(selectTabContentLast(ContentType.VIDEO));
  const nextCursor = useAppSelector(selectTabContentNextCursor(ContentType.VIDEO));
  const { searchQuery, columns } = usePerksConfig();

  const cssVars = {
    '--videoColumns': columns,
  };

  const filteredVideos = useMemo(() => {
    if (!videos) return [];
    if (!searchQuery) return videos;

    const query = searchQuery.toLowerCase();
    return videos.filter((video) => video.name?.toLowerCase().includes(query));
  }, [videos, searchQuery]);

  const handleLoadMore = () => {
    dispatch(loadTabContent({ contentType: ContentType.VIDEO, cursor: nextCursor, loadMore: true }));
  };

  if (loading && !videos?.length) {
    return (
      <section class="single-loading">
        <SpinnerComponent />
      </section>
    );
  }

  if (!videos) {
    return null;
  }

  return (
    <div class="single-perks-video-container" style={cssVars}>
      {filteredVideos.length > 0 ? (
        <>
          <section class="single-card-grid video-grid">
            {filteredVideos.map((video) => (
              <PerksVideo key={video.id} video={video} />
            ))}
          </section>
          {!searchQuery && !isLast && (
            <section className="single-load-more">
              <button className="button btn" onClick={handleLoadMore} disabled={loading}>
                {loading ? t('common.loading') : t('perks.loadMore')}
              </button>
            </section>
          )}
        </>
      ) : (
        <div class="no-results">
          {t('perks.noVideos')}
          {searchQuery && <span>&nbsp;{t('perks.foundFor', { query: searchQuery })}</span>}
        </div>
      )}
    </div>
  );
};
